import script from "./ModalConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./ModalConfirm.vue?vue&type=style&index=0&id=fdb74c8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdb74c8c"]])

export default __exports__